import { ObservableFromFetch } from "../ObservableFromFetch"
import ImplementationImage from "./Model/ImplementationImage"

export interface ImplementationImageData {
  ImplementationActiveImages: ImplementationImage[]
  ImplementationInActiveImages: ImplementationImage[]
}

export default function GetAllImplementationImageByImplementationID(implementationID: number) {
  const requestBody: string = new URLSearchParams({ ImplementationID: implementationID.toString() }).toString()
  return ObservableFromFetch<ImplementationImageData>("FFOrderClientFileMaintenance/GetAllImplementationImageByImplementationID?" + requestBody)
}
